import axios from "axios";

// In local development, we need to access the API directly
const baseURL = ""; // Empty string will use the current domain

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add request interceptor to handle failed requests in development
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Only attempt this in development mode and if error is connection-related
    if (
      process.env.NODE_ENV === "development" &&
      (error.code === "ECONNREFUSED" || error.message.includes("Network Error"))
    ) {
      console.log("Express server not running, trying local API route instead");

      // Create a new request to the local API route
      const localApi = axios.create({
        baseURL: "http://localhost:3000",
        headers: { "Content-Type": "application/json" },
      });

      // Get the original request config
      const originalRequest = error.config;

      try {
        // Retry with the local API endpoint
        const response = await localApi(originalRequest);
        return response;
      } catch (retryError) {
        return Promise.reject(retryError);
      }
    }

    return Promise.reject(error);
  }
);

export const registerUser = async (userData) => {
  try {
    const response = await api.post("/api/sheets", {
      type: "register",
      data: userData,
    });
    return response.data;
  } catch (error) {
    console.error("Register API error:", error.response?.data || error.message);
    throw error;
  }
};

export const submitContactForm = async (contactData) => {
  try {
    const response = await api.post("/api/sheets", {
      type: "contact",
      data: contactData,
    });
    return response.data;
  } catch (error) {
    console.error("Contact API error:", error.response?.data || error.message);
    throw error;
  }
};

export default api;
